import  {  useState } from "react";
import CustomizedAvatar from "../../commons/CircularAvatar/CustomizedAvatar";
import { ImageDataType } from "../../../commonTypes/fileManagerTypes";
import PdfPreview from "../../FileManager/Files/PdfPreview";
import Select from "react-select";
import { performanceEvaluationRatingDropdown } from "../../../constant/tableHeadersConstants/checkInScheduleListHeader";
import LeaveFileUpload from "../AllLeaves/LeaveFileUpload";
import { NewWhiteDownloadIcon } from "../../../assets/images";
import "./performanceEvaluationStyle.scss"

type AppProps = {
  data: any;
  feedbackComment: string;
  handleCommentChange: (data: any) => void;
  performanceRating: any;
  handlePerformanceRatingChange: (data: any) => void;
  type?:string;
  uploadFiles:(data:any)=>void;
  files:any;
  uploadFetching:boolean;
  handleDeleteUploadedFile:(data:number)=>void;
};
const ViewPerformanceEvaluationDetails = ({
  data,
  feedbackComment,
  handleCommentChange,
  performanceRating,
  handlePerformanceRatingChange,
  type,
  uploadFiles,
files,
uploadFetching,
handleDeleteUploadedFile
}: AppProps) => {
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;
  const [imageDetails, setImageDetails] = useState<ImageDataType>({
    imageUrl: "",
    downloadImage: "",
    fileType: "",
    finalFileName: "",
    updateBy: "",
    updatedAt: "",
  });

  const handleOpenPreview = (data: any) => {
    setImageDetails({
      ...data,
      imageUrl: blobBaseUrl + data.file_url + "?" + blobToken,
      downloadImage: data.file_url,
      fileType: data.file_type,
      finalFileName: data.file_name,
    });
  };


  return (
    <>
      <div
        style={{
          border: "1px solid #bfcbe1",
          padding: "20px 30px 20px 20px",
          marginLeft: "25px",
          marginTop: "25px",
          width: "77%",
          borderRadius:"5px"
        }}
      >
        <div
          style={{ fontSize: "16px", fontWeight: "500", marginBottom: "13px" }}
        >
          {" "}
          Employee Details
        </div>

        <div
          className="mt-2"
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div>
              <CustomizedAvatar
                name={data?.created_by?.first_name}
                image={
                  data?.created_by?.profile_pic?.file_url &&
                  data?.created_by?.profile_pic?.file_url
                }
                style={{ width: "60px", fontSize: "15px" }}
              />
            </div>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div
                style={{
                  color: "#262a44",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                {`${data?.created_by?.first_name} ${data?.created_by?.last_name}`}
              </div>
              <span
                style={{
                  color: "#6e7491",
                  fontWeight: "500",
                  fontSize: "13px",
                }}
              >
                {`${data?.created_by?.job_title?data?.created_by?.job_title:''}`}
              </span>
              <span
                style={{
                  color: "#6e7491",
                  fontWeight: "500",
                  fontSize: "13px",
                }}
              >
                {`${data?.created_by?.department? data?.created_by?.department:''}`}
              </span>
            </div>
          </div>
          <div className="d-flex flex-column">
            <span
              style={{
                color: "#6e7491",
                fontWeight: "500",
                fontSize: "13px",
                marginBottom: "5px",
              }}
            >
              Employee ID
            </span>

            <span
              style={{
                color: "#262a44",
                fontWeight: "normal",
                fontSize: "14px",
              }}
            >
              {data?.created_by?.employee_id?data?.created_by?.employee_id:"NA"}
            </span>
          </div>
          <div className="d-flex flex-column">
            <span
              style={{
                color: "#6e7491",
                fontWeight: "500",
                fontSize: "13px",
                marginBottom: "5px",
              }}
            >
              Reporting To
            </span>
            <div
              className="d-flex"
              style={{ gap: "5px", alignItems: "center" }}
            >
              <div>
                {data?.created_by?.reporting_person?.first_name? 
                <CustomizedAvatar
                  name={`${
                    data?.created_by?.reporting_person?.first_name
                      ? data?.created_by?.reporting_person?.first_name
                      : ""
                  } ${
                    data?.created_by?.reporting_person?.last_name
                      ? data?.created_by?.reporting_person?.last_name
                      : ""
                  }`}
                  image={
                    data?.created_by?.reporting_person?.profile_pic?.file_url &&
                    data?.created_by?.reporting_person?.profile_pic?.file_url
                  }
                  style={{ width: "30px", fontSize: "10px" }}
                />
                :""}
              </div>
              <div
                style={{
                  color: "#262a44",
                  fontWeight: "normal",
                  fontSize: "14px",
                }}
              >
                   {`${
                    data?.created_by?.reporting_person?.first_name
                      ? data?.created_by?.reporting_person?.first_name
                      : ""
                  } ${
                    data?.created_by?.reporting_person?.last_name
                      ? data?.created_by?.reporting_person?.last_name
                      : ""
                  }`}
              </div>
            </div>
          </div>
          <div className="d-flex flex-column">
            <span
              style={{
                color: "#6e7491",
                fontWeight: "500",
                fontSize: "13px",
                marginBottom: "5px",
              }}
            >
              Joining Date
            </span>

            <span
              style={{
                color: "#262a44",
                fontWeight: "normal",
                fontSize: "14px",
              }}
            >
              {data?.created_by?.joining_date
                ? data?.created_by?.joining_date
                : "NA"}
            </span>
          </div>
          <div className="d-flex flex-column">
            <span
              style={{
                color: "#6e7491",
                fontWeight: "500",
                fontSize: "13px",
                marginBottom: "5px",
              }}
            >
              Job Location
            </span>

            <span
              style={{
                color: "#262a44",
                fontWeight: "normal",
                fontSize: "14px",
              }}
            >
              {data?.created_by?.branch_name
                ? data?.created_by?.branch_name
                : "NA"}
            </span>
          </div>
        </div>
      </div>
      <div style={{ display: "flex", width: "100%", gap: "4%" }}>
        <div style={{ width: "48%" }}>
          <div className="d-flex mt-5 ml-5" style={{ width: "50%" }}>
            <div className="mr-5">
              <p
                style={{
                  color: "#262a44",
                  fontSize: "17px",
                  fontWeight: "500",
                }}
              >
                Submitted PE Details
              </p>

              <div className="d-flex mb-4" style={{ gap: "100px" }}>
                <div className="d-flex flex-column " style={{ width: "210px" }}>
                  <span
                    style={{
                      color: "#6e7491",
                      fontWeight: "500",
                      fontSize: "12px",
                      marginBottom: "5px",
                    }}
                  >
                    Title
                  </span>

                  <span
                    style={{
                      color: "#262a44",
                      fontWeight: "normal",
                      fontSize: "16px",
                    }}
                  >
                    {data?.title?data?.title:'NA'}
                  </span>
                </div>
                <div className="d-flex flex-column ">
                  <span
                    style={{
                      color: "#6e7491",
                      fontWeight: "500",
                      fontSize: "12px",
                      marginBottom: "5px",
                    }}
                  >
                    Total Hours Spent{" "}
                  </span>

                  <span
                    style={{
                      color: "#262a44",
                      fontWeight: "normal",
                      fontSize: "16px",
                    }}
                  >
                    {data?.hours?data?.hours:"NA"}
                  </span>
                </div>
                {/* <div></div> */}
              </div>
              <div
                className="d-flex mb-3"
                style={{ gap: "100px", width: "500px" }}
              >
                <div className="d-flex flex-column">
                  <span
                    style={{
                      color: "#6e7491",
                      fontWeight: "500",
                      fontSize: "12px",
                      marginBottom: "5px",
                    }}
                  >
                    Date Range
                  </span>

                  <span
                    style={{
                      color: "#262a44",
                      fontWeight: "normal",
                      fontSize: "16px",
                    }}
                  >
                    {`${data?.start_date} to ${data?.end_date}`}
                  </span>
                </div>
                <div className="d-flex flex-column">
                  <span
                    style={{
                      color: "#6e7491",
                      fontWeight: "500",
                      fontSize: "12px",
                      marginBottom: "6px",
                    }}
                  >
                    Manager{" "}
                  </span>
                   <div
              className="d-flex"
              style={{ gap: "5px", alignItems: "center" }}
            >
              <div>
                {data?.manager?.first_name? 
                <CustomizedAvatar
                  name={`${
                    data?.manager?.first_name
                      ? data?.manager?.first_name
                      : ""
                  } ${
                    data?.manager?.last_name
                      ? data?.manager?.last_name
                      : ""
                  }`}
                  image={
                    data?.manager?.profile_pic?.file_url &&
                    data?.manager?.profile_pic?.file_url
                  }
                  style={{ width: "30px", fontSize: "10px" }}
                />
                :""}
              </div>
              <span
               style={{
                color: "#262a44",
                fontWeight: "normal",
                fontSize: "16px",
              }}
              >
               {`${
                    data?.manager?.first_name
                      ? data?.manager?.first_name
                      : ""
                  } ${
                    data?.manager?.last_name
                      ? data?.manager?.last_name
                      : ""
                  }`}
              </span>
            </div>
                </div>
              </div>
              <p
                style={{
                  color: "#6e7491",
                  fontWeight: "500",
                  fontSize: "12px",
                  marginBottom: "5px",
                }}
              >
              Files Uploaded by Employee
              </p>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2,1fr)",
                  gap: "30px",
                }}
              >
                {data?.file_attachment?.length > 0 ? (
                  data.file_attachment.map((file: any, index: number) => (
                    <div key={index}>
                      <a
                        target="_blank"
                        onClick={() => handleOpenPreview(file)}
                        style={{ cursor: "pointer", color: "#007bff" }}
                      >
                        {file.file_name}
                      </a>
                    </div>
                  ))
                ) : (
                  <span   style={{
                    color: "#262a44",
                    fontWeight: "normal",
                    fontSize: "16px",
                  }}>No files</span>
                )}
              </div>
               {data?.manager_file_attachment?.length ? 
               <>
                 <p
                style={{
                  color: "#6e7491",
                  fontWeight: "500",
                  fontSize: "12px",
                  marginBottom: "5px",
                  marginTop:"17px"
                }}
              >
                Files Uploaded by Manager
              </p>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2,1fr)",
                  gap: "30px",
                }}
              >
                {data?.manager_file_attachment?.length > 0 ? (
                  data.manager_file_attachment.map((file: any, index: number) => (
                    <div key={index}>
                      <a
                        target="_blank"
                        onClick={() => handleOpenPreview(file)}
                        style={{ cursor: "pointer", color: "#007bff" }}
                      >
                        {file.file_name}
                      </a>
                    </div>
                  ))
                ) : (
                  <span   style={{
                    color: "#262a44",
                    fontWeight: "normal",
                    fontSize: "16px",
                  }}>No files</span>
                )}
              </div>
              </>
             :'' }
            </div>
         
          </div>
          <div style={{ marginLeft: "46px", marginTop: "25px", width: "76%" }}>
            <p
              style={{ color: "#262a44", fontSize: "17px", fontWeight: "500",marginBottom:'0px' }}
            >
              Add Your Feedback
            </p>
            <div className="d-flex flex-column mb-3">
              <label
                htmlFor="rating"
                style={{
                  color: "#6e7491",
                  fontWeight: "normal",
                  fontSize: "14px",
                  marginBottom: "5px",
                }}
              >
                Select Rating <span className="color-red">*</span>
              </label>
              <div className="col-md-8 pl-0">
                <Select
                  options={performanceEvaluationRatingDropdown}
                  value={performanceRating}
                  onChange={handlePerformanceRatingChange}
                  isDisabled={data?.rating || type=="MYPE"}

                />
              </div>
            </div>
            <div className="d-flex flex-column mb-3" style={{ width: "600px" }}>
              <label
                htmlFor="peComments"
                style={{
                  color: "#6e7491",
                  fontWeight: "500",
                  fontSize: "14px",
                  marginBottom: "5px",
                }}
              >
                Add PE Comments <span className="color-red">*</span>
              </label>
              <textarea
                className={`form-control`}
                name="text"
                value={feedbackComment}
                onChange={(e) => handleCommentChange(e.target?.value)}
                disabled={data?.feedback?.length || type=="MYPE"}

              />
            </div>
            {type=="MYPE" || data?.rating?"":
            <div className="d-flex flex-column mb-3">
              <div className="ml-2" style={{ width: "28%" }}>
              <LeaveFileUpload
                uploadFiles={uploadFiles}
                files={files}
                handleDeleteUploadedFile={handleDeleteUploadedFile}
                uploadFetching={uploadFetching}
              />
              <div>{uploadFetching ? `loading...` : ""}</div>
            </div>
            </div>
}
          
          </div>
        </div>
        <div
          style={{
            width: "48%",
            border: "1px solid #bfcbe1",
            margin: "65px 47px 20px 66px",
            height: "450px",
            overflow:'auto'
          }}
          className="previewImage"
        >
          <div style={{display:'flex',justifyContent:'space-between',alignItems:"center",padding:'5px'}}>
            <span>{imageDetails?.finalFileName}</span>
           {blobBaseUrl && imageDetails?.downloadImage && (
            <a
              href={blobBaseUrl + imageDetails?.downloadImage + "?" + blobToken}
              style={{ textDecoration: "none" }}
            >
           <button className="btn btn-primary"  style={{fontSize:'14px'}}
            disabled={!imageDetails?.imageUrl?.length}
>
                <span className="pr-2">
                  <img src={NewWhiteDownloadIcon} />
                </span>
                Download
              </button>
              </a>
          )}
          </div>
          {imageDetails?.imageUrl?.length != 0 ? (
            <>
              {imageDetails?.fileType === "application/msword" ||
              imageDetails?.fileType === "application/vnd.ms-excel" ||
              imageDetails?.fileType ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
              imageDetails?.fileType ===
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
              imageDetails?.fileType ===
                "application/vnd.openxmlformats-officedocument.presentationml.presentation" ||
              imageDetails?.fileType === "application/vnd.ms-powerpoint" ? (
                blobBaseUrl &&
                imageDetails?.downloadImage && (
                  <iframe
                    src={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
                      blobBaseUrl +
                        imageDetails?.downloadImage +
                        "?" +
                        blobToken
                    )}`}
                    width="100%"
                    height="400px"
                  />
                )
              ) : imageDetails?.fileType === "application/pdf" ? (
                <PdfPreview imageDetails={imageDetails} />
              ) : (
                <img
                  width="100%"
                  height="450px"
                  src={imageDetails?.imageUrl}
                  alt={`file_manager_${imageDetails?.finalFileName}`}
                />
              )}
            </>
          ) : (
            <p 
            style={{textAlign:'center', fontSize:'17px', fontWeight:'500', color:'#262a44', 
              marginTop:'198px'
            }}>Click on file name on left to preview here.</p>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewPerformanceEvaluationDetails;
